import { render, staticRenderFns } from "./login-dialog.vue?vue&type=template&id=3ff3124a&scoped=true&"
import script from "./login-dialog.vue?vue&type=script&lang=ts&"
export * from "./login-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./login-dialog.vue?vue&type=style&index=0&id=3ff3124a&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff3124a",
  null
  
)

export default component.exports